/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { doc, updateDoc } from "firebase/firestore";
import { firestore } from "../pages/firebaseConfig";
import { toast } from "react-toastify";

const EditProducts = ({ view, setView, state, fetchProducts }) => {
  const [fields, setFields] = useState(state);
  const [newFiles, setNewFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [replaceImages, setReplaceImages] = useState(false);

  const handleClose = () => {
    setView(false);
    setNewFiles([]);
    setReplaceImages(false);
  };

  useEffect(() => {
    setFields(state);
    setNewFiles([]);
    setReplaceImages(false);
  }, [state]);

  const uploadToCloudinary = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch("/api/upload", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.message || "Upload failed");
      }

      return data.imageUrl;
    } catch (error) {
      console.error("Cloudinary upload error:", error);
      throw error;
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    await handleUpdate(fields);
  };

  const handleUpdate = async (fields) => {
    setIsLoading(true);

    try {
      let imageUrls = fields.imageUrls || [];

      // If user wants to replace images and has selected new files
      if (replaceImages && newFiles.length > 0) {
        toast.info("Uploading new images...");
        const uploadPromises = newFiles.map((file) => uploadToCloudinary(file));
        imageUrls = await Promise.all(uploadPromises);
      }

      const docRef = doc(firestore, "products", fields.id);

      await updateDoc(docRef, {
        title: fields.title,
        description: fields.description,
        category: fields.category,
        sold: fields.sold === "true" || fields.sold === true,
        status: fields.status === "true" || fields.status === true,
        imageUrls: imageUrls,
      });

      toast.success("Product updated successfully");
      setIsLoading(false);
      handleClose();
      await fetchProducts();
    } catch (error) {
      setIsLoading(false);
      console.error(error);
      toast.error("Failed to update product: " + error.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFields({ ...fields, [name]: value });
  };

  const handleFileChange = (e) => {
    const selectedFiles = e.target.files;
    setNewFiles([...selectedFiles]);
  };

  return (
    <Modal show={view} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Edit Product</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={onSubmit}>
          <div className="form-group mb-3">
            <label>Title</label>
            <input
              type="text"
              value={fields.title || ""}
              name="title"
              onChange={handleChange}
              placeholder="Product Title"
              className="form-control"
              required
            />
          </div>

          <div className="form-group mb-3">
            <label>Category</label>
            <select
              value={fields.category || ""}
              name="category"
              onChange={handleChange}
              className="form-control"
              required
            >
              <option value="">Select Category</option>
              <option value="furniture">Furniture</option>
              <option value="lighting">Lighting</option>
              <option value="vases">Vases/Pots</option>
              <option value="mirror">Mirrors</option>
              <option value="plants">Plants</option>
              <option value="accessories">Accessories</option>
              <option value="wallart">Wall Art</option>
            </select>
          </div>

          <div className="form-group mb-3">
            <label>Status</label>
            <select
              value={fields.status || "false"}
              onChange={handleChange}
              name="status"
              required
              className="form-control"
            >
              <option value="false">Regular</option>
              <option value="true">Latest</option>
            </select>
          </div>

          <div className="form-group mb-3">
            <label>Availability</label>
            <select
              value={fields.sold || "false"}
              onChange={handleChange}
              name="sold"
              required
              className="form-control"
            >
              <option value="false">Available</option>
              <option value="true">Sold Out</option>
            </select>
          </div>

          <div className="form-group mb-3">
            <label>Description</label>
            <textarea
              className="form-control"
              name="description"
              value={fields.description || ""}
              onChange={handleChange}
              placeholder="Product Description"
              rows="4"
              required
            ></textarea>
          </div>

          <div className="form-group mb-3">
            <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="checkbox"
                id="replaceImages"
                checked={replaceImages}
                onChange={(e) => setReplaceImages(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="replaceImages">
                Replace existing images
              </label>
            </div>

            {replaceImages && (
              <>
                <label>New Images</label>
                <input
                  type="file"
                  onChange={handleFileChange}
                  className="form-control"
                  multiple
                  accept="image/*"
                />
                {newFiles.length > 0 && (
                  <small className="form-text text-muted">
                    {newFiles.length} new file(s) selected
                  </small>
                )}
              </>
            )}

            {!replaceImages && fields.imageUrls && fields.imageUrls.length > 0 && (
              <small className="form-text text-muted">
                Current images: {fields.imageUrls.length}
              </small>
            )}
          </div>

          <div className="form-group">
            <Button
              type="submit"
              variant="primary"
              disabled={isLoading}
              className="w-100"
            >
              {isLoading ? "Updating..." : "Update Product"}
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default EditProducts;